import { render, staticRenderFns } from "./CardFacilityPage.vue?vue&type=template&id=fb75bc82&"
import script from "./CardFacilityPage.vue?vue&type=script&lang=js&"
export * from "./CardFacilityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports